import  { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

const ProductTypeChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;
 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/logisticJson`
        );
        const rawData = response.data.data.Data;

        const drivers = [...new Set(rawData.map(item => item["Drivers"]))];

        const firewoodData = drivers.map(driver => {
          const driverData = rawData.filter(item => item["Drivers"] === driver);
          return driverData.reduce((total, item) => total + item["Firewood"], 0);
        });

        const pelletsData = drivers.map(driver => {
          const driverData = rawData.filter(item => item["Drivers"] === driver);
          return driverData.reduce((total, item) => total + item["Pellets"], 0);
        });

        const datasets = [
          {
            label: 'Firewood',
            data: firewoodData,
            backgroundColor: 'rgba(75, 192, 192, 0.6)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
          },
          {
            label: 'Pellets',
            data: pelletsData,
            backgroundColor: 'rgba(255, 99, 132, 0.6)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1,
          }
        ];

        setChartData({
          labels: drivers,
          datasets: datasets,
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      scales: {
        x: {
          beginAtZero: true,
          barPercentage: 0.5, // Adjust this value to set the width of the bars
          categoryPercentage: 0.5, // Adjust this value to set the width of the bars
        },
        y: {
          beginAtZero: true,
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: 'white',
            font: {
              size: 14
            }
          }
        }
      },
      elements: {
        bar: {
          maxBarThickness: 80, // Adjust this value to set the thickness of the bars
        }
      },
      animations: {
        radius: {
          duration: 400,
          easing: 'linear',
          loop: (context) => context.active
        }
      },
      hoverRadius: 12,
      hoverBackgroundColor: 'yellow',
      interaction: {
        mode: 'nearest',
        intersect: false,
        axis: 'x'
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Weight of Firewood and Pellets by Driver
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Bar
              data={chartData}
              options={options}
            />
          </div>
        </Container>
      </div>
    );
  }
};

export default ProductTypeChart;
